import React, { Component } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { mixpanel, links, constants, snowplow } from 'common/helpers'

import Button from 'components/buttons/Button/Button'
import Modal from 'components/modal/Modal/Modal'

import UnsubscribeProduct from './UnsubscribeProduct/UnsubscribeProduct'

import messages from './messages'
import s from './UnsubscribeProductsModal.scss'

// resolve picture x2
import handCreamsImageMobile from './images/handCreams/mobile.jpg'
// resolve picture x2
import handCreamsImageDesktop from './images/handCreams/desktop.jpg'

// resolve picture x2
import productsForBodyImageMobile from './images/productsForBody/mobile.jpg'
// resolve picture x2
import productsForBodyImageDesktop from './images/productsForBody/desktop.jpg'

// resolve picture x2
import scentedCandlesImageMobile from './images/scentedCandles/mobile.jpg'
// resolve picture x2
import scentedCandlesImageDesktop from './images/scentedCandles/desktop.jpg'

// resolve picture x2
import bodyLipImageMobile from './images/bodyLip/mobile.jpg'
// resolve picture x2
import bodyLipImageDesktop from './images/bodyLip/desktop.jpg'


const products = [
  {
    id: 'handCreams',
    title: messages.handCreams,
    link: links.handCreams,
    imageDesktop: handCreamsImageDesktop,
    imageMobile: handCreamsImageMobile,
  },
  {
    id: 'productsForBody',
    title: messages.personalCare,
    link: links.personalCare,
    imageDesktop: productsForBodyImageDesktop,
    imageMobile: productsForBodyImageMobile,
  },
  {
    id: 'scentedCandles',
    title: messages.scentedCandles,
    link: links.candles,
    imageDesktop: scentedCandlesImageDesktop,
    imageMobile: scentedCandlesImageMobile,
  },
  {
    id: 'bodyLip',
    title: messages.bodyLip,
    link: links.bodyLip,
    imageDesktop: bodyLipImageDesktop,
    imageMobile: bodyLipImageMobile,
  },
]


class UnsubscribeProductsModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.UnsubscribeProducts,
    data: {
      reason: 'MANY_PERFUMES',
      comment: '',
    },
  }

  handleContinueCancellationClick = () => {
    const { data } = this.props

    actions.models.subscription.unsubscribe(data)
      .then(({ isRefundAvailable, refund }) => {
        this.close()

        if (isRefundAvailable || refund) {
          actions.models.modals.open(constants.modals.cancelSubscription.Refund, refund)
        }
        else {
          actions.models.modals.open(constants.modals.cancelSubscription.SubscriptionWasCancelled)
        }
      })
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  trackCloseModal = (action, props = {}) => {
    snowplow.track(constants.snowplowEvents.cancelSubscriptionStepComplete, {
      stepName: 'try other products',
      action,
      ...props,
    }, false)
  }

  handleProductClick = (product) => {
    this.trackCloseModal('product click', {
      productName: product.id,
    })
    this.close()
  }

  handleCloseClick = () => {
    // TODO its weird - we don't need reason on this step
    const { data: { reason } } = this.props

    mixpanel.track(constants.analyticsEvents.stopUnsubscribe, {
      type: reason,
    })
    this.trackCloseModal('close')
    this.close()
  }

  handleCloseModal = () => {
    this.trackCloseModal('close')
  }

  render() {
    const { name } = this.props

    return (
      <Modal
        className={s.modal}
        name={name}
        title={messages.title}
        onClick={this.handleCloseModal}
      >
        <div className={s.products}>
          {
            products.map((product, index) => (
              <div key={index} className={s.productContainer}>
                <UnsubscribeProduct {...product} onChoose={() => this.handleProductClick(product)} />
              </div>
            ))
          }
        </div>
        <div className={s.buttons}>
          <Button
            className={s.button}
            noPadding
            xlg
            emptyGray
            title={messages.close}
            onClick={this.handleCloseClick}
          />
          <Button
            className={s.button}
            noPadding
            xlg
            gray
            title={messages.cancelSubscription}
            onClick={this.handleContinueCancellationClick}
          />
        </div>
      </Modal>
    )
  }
}


export default UnsubscribeProductsModal
